module.exports = __webpack_public_path__ + "img/gwnu_detail.2d7fe76f.jpg";